import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Col, Input, Row, Table, message } from "antd";
import { ColumnType } from "antd/es/table";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../store/main/mainSlice";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { useTranslation } from "react-i18next";
interface Props {
  setSelectedItem: any;
  setIsDetailsOpen: Dispatch<SetStateAction<boolean>>;
  search: string;
  isItemLoading: boolean;
  setIsQuantityInStock: Dispatch<SetStateAction<boolean>>;
}
type Item = {
  localId: number;
  name: string;
  itemId: number;
  barcode: string;
  cost: number;
  price: number;
  totalPrice: number;
  isTaxable: boolean;
  extraCharge: number;
  tax: number;
  discount: null | number;
  notes: string;
  qty: number;
  qtyInStock: number;
  specifications: any[];
};

const MainTable = ({
  setSelectedItem,
  setIsDetailsOpen,
  search,
  isItemLoading,
  setIsQuantityInStock
}: Props) => {
  interface DataSourceItem {
    localId: number;
    barcode: string;
    name: string;
    author: string;
    year: string;
    description: string;
    qtyInStock: number;
    qty: number;
    price: number;
    total: number;
    image: string;
  }
  type itemType = {
    localId: number;
    name: string;
    itemId: number;
    barcode: string;
    cost: number;
    price: number;
    totalPrice: number;
    isTaxable: boolean | null;
    extraCharge: number;
    tax: number;
    discount: number | null;
    notes: string;
    qty: number;
    qtyInStock: number;
    specifications: [];
  };

  function getTotalQuantities(items: itemType[]): Record<string, number> {
    const quantities: Record<string, number> = {};

    items.forEach((item) => {
      if (quantities[item.itemId]) {
        quantities[item.itemId] += item.qty;
      } else {
        quantities[item.itemId] = item.qty;
      }
    });

    return quantities;
  }

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const items = useSelector((state: any) => state.main.items);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const [selectedItemToDelete, setSelectedItemToDelete] = useState<number>(0);
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Quantity Exceeds Stock",
    });
  };

  const [t] = useTranslation("common");

  const columns: ColumnType<DataSourceItem>[] = [
    {
      title: `${t("barcode")}`,
      dataIndex: "barcode",
      key: "barcode",
      width: "10%",
      className: "table-header main",
    },
    {
      title: `${t("name")}`,
      dataIndex: "name",
      key: "name",
      className: "table-row main",
      width: "30%",
    },
    {
      title: `${t("in-stock")}`,
      dataIndex: "qtyInStock",
      key: "qtyInStock",
      className: "table-row main",
      width: "15%",
    },
    {
      title: `${t("quantity")}`,
      width: "10%",
      key: "qty",
      className: "table-row main",
      render: (record) => {
        const exceedsStock = getTotalQuantities(items)[record.itemId] > record.qtyInStock
        setIsQuantityInStock(exceedsStock)
        return (
          <>
            <Input
              min={"1"}
              max="100000"
              value={record.qty}
              style={{ height: "30px", borderColor: exceedsStock ? 'red' : '' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onBlur={(e) => {
                const inputValue = e.target.value;
                if (Number(inputValue) === 0) {
                  dispatch(
                    mainActions.setQty({
                      id: record.localId,
                      qty: 1,
                    })
                  );
                }
              }}
              onChange={(e) => {
                const inputValue = Number(e.target.value);
                dispatch(
                  mainActions.setQty({
                    id: record.localId,
                    qty: Number(inputValue),
                  })
                );
              }}
            />
          </>
        );
      },
    },
    {
      title: `${t("price")}`,
      dataIndex: "price",
      key: "price",
      width: "10%",
      className: "table-row main",
      render: (record) => {
        return <> {record?.toFixed(2)}</>;
      },
    },
    {
      title: `${t("total")}`,
      key: "total",
      width: "15%",
      className: "table-row main",
      render: (record) => {
        return <> {(record.price * record.qty).toFixed(2)}</>;
      },
    },
    {
      title: `${t("actions")}`,
      key: "actions",
      align: "center",
      width: "10%",
      className: "table-row main",
      render: (record) => {
        return (
          <Row justify={"space-around"}>
            <Col span={12}>
              <ExclamationCircleOutlined
                style={{ fontSize: "20px" }}
                onClick={() => {
                  setSelectedItem(record);
                  setIsDetailsOpen(true);
                }}
              />
            </Col>
            <Col span={12}>
              <DeleteOutlined
                style={{ fontSize: "20px", color: "red" }}
                onClick={() => {
                  setSelectedItemToDelete(record?.localId);
                  setIsOpenDelete(true);
                }}
              />
            </Col>
          </Row>
        );
      },
    },
  ];
  return (
    <>
      {contextHolder}
      <Table
        className="main ant-table-thead"
        dataSource={items.filter(
          (item: Item) =>
            item.name.toLowerCase().includes(search.toLowerCase()) ||
            item.barcode.includes(search)
        )}
        columns={columns}
        loading={isItemLoading}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record: DataSourceItem) => record.localId.toString()}
        pagination={{ pageSize: 14 }}
      />
      <DeleteModal
        open={isOpenDelete}
        setOpen={setIsOpenDelete}
        onOk={() => {
          dispatch(mainActions.deleteItem({ id: selectedItemToDelete }));
        }}
        name={""}
      />
    </>
  );
};

export default MainTable;
